import React from "react";

import css from "./footer.module.css";

export const Footer = () => {
  return (
    <footer className={css.footer}>
      <div className={css.inner}>
        <span>&copy; {new Date().getFullYear()} Valmont Industries, Inc.</span>
        <span className={css.separator}>|</span>
        <a href="https://www.valleyirrigation.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <span className={css.separator}>|</span>
        <a href="https://www.valleyirrigation.com/legal-policy" target="_blank" rel="noopener noreferrer">Legal Policy</a>
      </div>
    </footer>
  );
};
